export default function Features() {
  const features = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Modular Design',
      description: 'Flexible and adaptable tent systems that can be configured to suit any event space or requirement'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Budget-Friendly Solutions',
      description: 'Premium stretch tents at competitive prices. Get outstanding value without compromising on quality'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Warranty',
      description: 'Industry-leading warranty coverage on all our stretch tent products and materials'
    },
    {
      icon: 'ri-fire-line',
      title: 'Fire Rated',
      description: 'All fabrics meet international fire safety standards and certifications for peace of mind'
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Impeccable Waterproofing',
      description: 'Engineered with advanced waterproof fabrics that keep guests completely dry in any weather condition'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Premier Tent Rentals Nationwide
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our custom Pop Pro Tents® stretch tents are designed to bring a touch of magic to any occasion. With a wide range of colors, shapes, and sizes available, we offer the perfect solution to make your event POP! We are experts in delivering exceptional experiences for your events and celebrations.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center group hover:transform hover:scale-105 transition-all duration-300"
            >
              <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-teal-400 to-teal-600 rounded-2xl flex items-center justify-center group-hover:shadow-xl transition-shadow">
                <i className={`${feature.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}